import { Chip } from "@mui/material"
import type { FC } from "react"

export const DealerChip: FC = () => {
  return <Chip label={"Dealer"} size={"small"} color={"info"} />
}
